
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/embedVideo/[id]",
      function () {
        return require("private-next-pages/embedVideo/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/embedVideo/[id]"])
      });
    }
  